import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IBulkChangeUsers {
  id: number;
  userId: number;
  totalDocs: number;
  totalCount: number;
  names: string[];
}

export class IBulkChangeUsersListResponse extends IPagination {
  @Type(() => IBulkChangeUsers)
  results: IBulkChangeUsers[];
}

export class IBulkChangeUsersQueryDto extends IQueryPaginationDto {
  createdAtStart?: string;
  createdAtEnd?: string;
}
